import {
  preloadQueryHash,
  Routes,
  QuickloadResponse,
  MemberHeaderDocument,
} from '@trello/quickload';

import { client, syncDeltaToCache, DataWithId } from '@trello/graphql';

export const hydrateApolloCacheFromQuickloadResults = (
  results: QuickloadResponse[],
): void => {
  const path = window.location.pathname;
  const preloadKeyMatch = Object.keys(preloadQueryHash).find((routeRegExp) =>
    new RegExp(routeRegExp).test(path),
  ) as Routes | undefined;
  const preloadMatch = preloadKeyMatch && preloadQueryHash[preloadKeyMatch];

  if (results.length === 0) {
    return;
  }

  if (!results[0]?.[0]) {
    return;
  }

  const headerData = (results[0][0] as unknown) as DataWithId;

  syncDeltaToCache(client, 'Member', headerData, {
    fromDocument: MemberHeaderDocument,
  });

  if (!preloadMatch) {
    return;
  }

  // start at 1 to omit header
  let index = 1;
  for (const { query, modelName } of preloadMatch.queries) {
    const data = results[index]?.[0];

    if (!data) {
      continue;
    }

    syncDeltaToCache(client, modelName, (data as unknown) as DataWithId, {
      fromDocument: query,
    });
    index++;
  }
};
